export const initialState = {
    data: {
        branches: [],
    },

    dialogs: {
        deleteConfirm: false,
        selectedRecord: null,
    },

    loading: {
        isLoadingBackdrop: false,
        isBackgroundRefreshing: false,
    },

    table: {
        searchInput: "",
        currentPage: 1,
        recordsPerPage: 10,
    },
};

export function manageBranchesReducer(state, action) {
    switch (action.type) {
        case "SET_BRANCHES":
            return {
                ...state,
                data: {
                    ...state.data,
                    branches: action.payload || [],
                },
            };

        case "OPEN_DELETE_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    deleteConfirm: true,
                    selectedRecord: action.payload,
                },
            };

        case "CLOSE_DELETE_DIALOG":
            return {
                ...state,
                dialogs: {
                    ...state.dialogs,
                    deleteConfirm: false,
                    selectedRecord: null,
                },
            };

        case "SET_LOADING":
            return {
                ...state,
                loading: {
                    ...state.loading,
                    [action.payload.key]: action.payload.value,
                },
            };

        case "SET_SEARCH_INPUT":
            return {
                ...state,
                table: { ...state.table, searchInput: action.payload, currentPage: 1 },
            };

        case "SET_CURRENT_PAGE":
            return {
                ...state,
                table: { ...state.table, currentPage: action.payload },
            };

        default:
            return state;
    }
}
